import { render } from "./UfcScores.vue?vue&type=template&id=2c160648&scoped=true"
import script from "./UfcScores.vue?vue&type=script&lang=js"
export * from "./UfcScores.vue?vue&type=script&lang=js"

import "./UfcScores.vue?vue&type=style&index=0&id=2c160648&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c160648"]])

export default __exports__